// extracted by mini-css-extract-plugin
export default {"question":"RemoveParticipantModal__question___RI_9Z"};